/**
 * PDP Visit Tracking
 * Tracks when user visits 6 unique product pages
 * Optimized with caching and efficient storage
 */

(function () {
  'use strict';

  // Configuration
  const REQUIRED_VISITS = 6;
  const EVENT_DELAY = 5000; // 5 seconds
  const STORAGE_KEY = 'pdp_visit_count';
  const VISITED_PRODUCTS_KEY = 'pdp_visited_products';
  const EVENT_NAME = 'pdp_6_visits_reached';

  // Use global storage utility if available
  const storage = window.ThemeStorage || {
    get: (key) => localStorage.getItem(key),
    set: (key, value) => localStorage.setItem(key, value),
    remove: (key) => localStorage.removeItem(key),
  };

  // Cache for visited products (avoid repeated JSON parsing)
  let visitedProductsCache = null;

  // Get current product identifier
  function getCurrentProductIdentifier() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return 'product-' + window.ShopifyAnalytics.meta.product.id;
    }
    return window.location.pathname;
  }

  // Get visited products list (with caching)
  function getVisitedProducts() {
    if (visitedProductsCache !== null) {
      return visitedProductsCache;
    }

    try {
      const visited = storage.get(VISITED_PRODUCTS_KEY);
      visitedProductsCache = visited ? JSON.parse(visited) : [];
      return visitedProductsCache;
    } catch (e) {
      console.warn('Failed to parse visited products:', e);
      visitedProductsCache = [];
      return visitedProductsCache;
    }
  }

  // Check if product already counted
  function isProductAlreadyCounted(productId) {
    try {
      const products = getVisitedProducts();
      return products.includes(productId);
    } catch (e) {
      return false;
    }
  }

  // Mark product as counted
  function markProductAsCounted(productId) {
    try {
      let products = getVisitedProducts();
      if (!products.includes(productId)) {
        products.push(productId);
        storage.set(VISITED_PRODUCTS_KEY, JSON.stringify(products));
        visitedProductsCache = products; // Update cache
        return true;
      }
      return false;
    } catch (e) {
      console.error('Failed to mark product as counted:', e);
      return false;
    }
  }

  // Get visit count (with validation)
  function getVisitCount() {
    try {
      const count = storage.get(STORAGE_KEY);
      const parsed = count ? parseInt(count, 10) : 0;
      return isNaN(parsed) ? 0 : parsed;
    } catch (e) {
      return 0;
    }
  }

  // Save visit count
  function saveVisitCount(count) {
    try {
      return storage.set(STORAGE_KEY, count.toString());
    } catch (e) {
      console.error('Failed to save visit count:', e);
      return false;
    }
  }

  // Trigger the 6 visits event
  function triggerPDP6VisitsEvent(visitCount) {
    console.log('🎯 Triggering PDP 6 visits event after ' + EVENT_DELAY / 1000 + ' seconds...');

    const eventData = {
      visitCount: visitCount,
      threshold: REQUIRED_VISITS,
      timestamp: new Date().toISOString(),
    };

    // Use EventTracker if available
    if (window.EventTracker) {
      window.EventTracker.trigger(EVENT_NAME, eventData, EVENT_DELAY);
    } else {
      setTimeout(function () {
        if (typeof $ !== 'undefined') {
          $('html').trigger(EVENT_NAME, eventData);
        } else if (typeof jQuery !== 'undefined') {
          jQuery('html').trigger(EVENT_NAME, eventData);
        } else if (window.CustomEvent) {
          window.dispatchEvent(
            new CustomEvent(EVENT_NAME, {
              detail: eventData,
              bubbles: true,
            })
          );
        }
        console.log('✓ Event triggered:', EVENT_NAME);
        console.log('🎉 User has visited', REQUIRED_VISITS, 'product pages!');
      }, EVENT_DELAY);
    }
  }

  // Track PDP visit
  function trackPDPVisit() {
    const productId = getCurrentProductIdentifier();

    // Check if already counted
    if (isProductAlreadyCounted(productId)) {
      console.log('📦 Product already counted, skipping...');
      return;
    }

    // Get current count
    let visitCount = getVisitCount();

    // Check if already reached threshold
    if (visitCount >= REQUIRED_VISITS) {
      console.log('✓ User has already visited', REQUIRED_VISITS, 'products');
      return;
    }

    // Increment count
    visitCount++;
    console.log('📦 PDP visit count:', visitCount, '/', REQUIRED_VISITS);

    // Save count
    if (!saveVisitCount(visitCount)) {
      console.error('Failed to save visit count');
      return;
    }

    // Mark product as counted
    markProductAsCounted(productId);

    // Check if threshold reached
    if (visitCount === REQUIRED_VISITS) {
      triggerPDP6VisitsEvent(visitCount);
    }
  }

  // Reset function for testing
  window.resetPDPCounter = function () {
    storage.remove(STORAGE_KEY);
    storage.remove(VISITED_PRODUCTS_KEY);
    visitedProductsCache = null;
    console.log('✓ PDP counter reset');
  };

  // Track visit on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPDPVisit);
  } else {
    trackPDPVisit();
  }
})();